import { LicenseManager } from 'ag-grid-enterprise';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';

LicenseManager.setLicenseKey(environment.license.agGrid);
platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
